export enum EVariableIncomeInvestmentSteps {
  INVESTMENT,
  PREVIEW,
  CONCLUSION
}
